import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RootState } from '../../../Redux/Store';
import { AppContext } from '../../../Context/AppContext';
import { useAppDispatch, useAppSelector } from '../../../Hooks/Hooks';
import { getContentStackData } from '../../../Redux/Reducers/ContentOrConfigSlice';
import { TMoreMenuSubTabProps } from './MoreMenuSubTab.type';
import { getContentFromUID } from '../../Support/Support';
import './MoreMenuSubTab.scss';

const MoreMenuSubTab = (props: TMoreMenuSubTabProps) => {
  const { isMobile } = useContext(AppContext);
  const { pathname } = useLocation();
  const { contentStackData, showBanner } = useAppSelector(
    (state: RootState) => state.ContentOrConfig,
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isMobile) navigate('/support');
  }, [isMobile, navigate]);
  useEffect(() => {
    if (
      [
        ...(contentStackData?.accordion_content ?? []),
        ...(contentStackData?.tabbed_accordion_content ?? []),
      ]?.length === 0
    )
      dispatch(
        getContentStackData({
          queryPayload: {
            contentType: 'tabbed_content,accordion_content,tabbed_accordion_content',
          },
        }),
      );
  }, [contentStackData?.accordion_content, contentStackData?.tabbed_accordion_content, dispatch]);

  const uid = pathname?.split('/')?.[pathname?.split('/')?.length - 1];

  return (
    <div className={`MoreMenuSubTab${showBanner ? ' AlertBannerVisible' : ''}`}>
      {!!getContentFromUID(uid, contentStackData)?.content ? (
        <div
          className="Accordion_Content"
          dangerouslySetInnerHTML={{
            __html: getContentFromUID(uid, contentStackData)?.content,
          }}
        />
      ) : (
        <div className="Tabbed_Accordion_Content">
          {getContentFromUID(uid, contentStackData)?.accordion_content?.map((item: any) => {
            return (
              <React.Fragment key={item?.uid}>
                <div className="Accordion_Content">
                  <div className="Content_Title_Container">
                    <p className="Content_Title">
                      {getContentFromUID(item?.uid, contentStackData)?.heading}
                    </p>
                    {!isMobile && (
                      <div className="Accordion_Arrow">
                        <img src="/oo/assets/icon/grid-down-arrow.svg" alt="Arrow icon" />
                      </div>
                    )}
                  </div>
                  {!!getContentFromUID(item?.uid, contentStackData)?.content ? (
                    <div
                      className="FAQ content"
                      dangerouslySetInnerHTML={{
                        __html: getContentFromUID(item?.uid, contentStackData)?.content,
                      }}
                    />
                  ) : (
                    getContentFromUID(item?.uid, contentStackData)?.faq?.map((faq: any) => {
                      return (
                        <div key={faq?._metadata?.uid}>
                          <div
                            className="FAQ question"
                            dangerouslySetInnerHTML={{
                              __html: "<span class = 'indicator'>Q. </span>" + faq?.question,
                            }}
                          />
                          <div
                            className="FAQ answer"
                            dangerouslySetInnerHTML={{
                              __html: "<span  class = 'indicator'>A. </span>" + faq?.answer,
                            }}
                          />
                        </div>
                      );
                    })
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MoreMenuSubTab;
